import React, { Component } from "react";
import { connect } from "react-redux";

import Row from "../../../../common/grid/Row";
import Col from "../../../../common/grid/Col";
import Accordion from "../../../../common/accordion/Accordion.js";
import Timesheet from "../../timesheet/Timesheet.js";
import { fetchUser } from "../../../../actions/user.js";
import "./UserDetails.css";

class UserDetails extends Component {
  componentDidMount() {
    this.props.fetchUser(this.props.match.params.id);
  }

  renderProjects() {
    const userProject = this.props.user.project;
    const { projects } = this.props.user;
    return (
      <div>
        {userProject && (
          <div>
            <div className="box">
              <img className="thumbnail" src={userProject.photo_url} alt="" />
              <h3 className="name">{userProject.name}</h3>
              <span className="author">
                <strong>Created at:</strong> {userProject.created_at}
              </span>
              <span className="author">
                <strong>Created by:</strong>{" "}
                {this.props.user.first_name + " " + this.props.user.last_name}
              </span>
            </div>
            <hr />
          </div>
        )}
        {projects.length > 0 &&
          projects.map((p, i) => {
            return (
              <div className="box" key={i}>
                <img className="thumbnail" src={p.photo_url} alt="" />
                <h3 className="name">{p.name}</h3>
                <span className="author">
                  <strong>Created at:</strong> {p.created_at}
                </span>
                <span className="author">
                  <strong>Created by:</strong>{" "}
                  {p.user.first_name + " " + p.user.last_name}
                </span>
              </div>
            );
          })}
        {projects.length === 0 && (
          <div>User is not associated with any projects</div>
        )}
      </div>
    );
  }

  render() {
    if (this.props.user) {
      return (
        <Row _gap-32 profile _no-grow-first>
          <Col _bottom-16 _no-grow profile-thumbnail>
            <div className="thumbnail">
              <img src={this.props.user.profile_photo_url} alt="" />
            </div>
          </Col>
          <Col _bottom-64>
            <Accordion>
              <div title="User Info" className="user-details">
                <Row>
                  <Col _bottom-4>
                    <div className="key">first name</div>
                    <div className="value">{this.props.user.first_name}</div>
                  </Col>
                  <Col _bottom-4>
                    <div className="key">last name</div>
                    <div className="value">{this.props.user.last_name}</div>
                  </Col>
                </Row>
                <Row>
                  <Col _bottom-4>
                    <div className="key">email</div>
                    <div className="value">{this.props.user.email}</div>
                  </Col>
                  <Col _bottom-4>
                    <div className="key">phone</div>
                    <div className="value">{this.props.user.phone}</div>
                  </Col>
                </Row>
                <Row>
                  <Col _bottom-4>
                    <div className="key">Role(s)</div>
                    <div className="value">
                      {this.props.user.roles.map((r, i) =>
                        i !== this.props.user.roles.length - 1
                          ? r.display_name + ", "
                          : r.display_name
                      )}
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col _bottom-4>
                    <div className="key">Contract</div>
                    {this.props.user.contract_url && (
                      <div className="value">
                        <a href={this.props.user.contract_url}>
                          Download current contract
                        </a>
                      </div>
                    )}
                    {!this.props.user.contract_url && (
                      <div className="value">
                        Contract has not been uploaded
                      </div>
                    )}
                  </Col>

                  <Col _bottom-4>
                    <div className="key">Agreement</div>
                    {this.props.user.agreement_url && (
                      <div className="value">
                        <a href={this.props.user.agreement_url}>
                          Download current agreement
                        </a>
                      </div>
                    )}
                    {!this.props.user.agreement_url && (
                      <div className="value">
                        Agreement has not been uploaded
                      </div>
                    )}
                  </Col>
                </Row>
                <Row>
                  <Col _bottom-4>
                    <div className="key">Job Description</div>
                    {this.props.user.job_description_url && (
                      <div className="value">
                        <a href={this.props.user.job_description_url}>
                          Download current job description
                        </a>
                      </div>
                    )}
                    {!this.props.user.job_description_url && (
                      <div className="value">
                        Job description has not been uploaded
                      </div>
                    )}
                  </Col>
                </Row>
              </div>
              <div title="Projects" className="user-projects">
                {this.renderProjects()}
              </div>
              <div title="Timesheet" className="expanded">
                <Timesheet
                  readOnly={true}
                  userId={this.props.match.params.id}
                />
              </div>
            </Accordion>
          </Col>
        </Row>
      );
    } else {
      return <div></div>;
    }
  }
}

const mapStateToProps = state => {
  return {
    user: state.user.selectedUser
  };
};

export default connect(
  mapStateToProps,
  { fetchUser }
)(UserDetails);



// WEBPACK FOOTER //
// ./src/components/main/user-management/details/UserDetails.js